// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3YUeq","addWidgetButton":"Header_addWidgetButton__22_b_","dashboardTabs":"Header_dashboardTabs__3-NkV","active":"Header_active__8OAKc"};